import { shown, type Sections } from '../../shared/sections'
import { forMe, posts, type UseSection } from '../../shared/uses'
import type { Me } from './api'
import { useFamily, type Family } from './families'
import { useFrame } from './frame'
import { useMe } from './useMe'

// What the circle you're in shows: the owner's switches, then the circle's own (Grow this circle). Pages that have
// their circle at hand use circleSections(me.sections, family) directly.
export const circleSections = (app: Sections, family?: Pick<Family, 'sections'> | null) => shown(app, family?.sections)

// What your own tabs and Home show: the circle's sections, less any you've turned off for yourself (What I use).
// Everywhere else (someone's page, a link to a recipe) still shows what the circle has.
export const mySections = (me: Pick<Me, 'sections' | 'uses'>, family?: Pick<Family, 'sections'> | null) =>
  forMe(circleSections(me.sections, family), me.uses)

export function useSections(): Sections | undefined {
  const me = useMe().data
  const { familyId } = useFrame()
  const family = useFamily(familyId ?? '', { enabled: !!familyId })
  return me ? mySections(me, family.data) : undefined
}

// Whether you add to this section yourself: false where you've picked Just see.
export function usePosts(section: UseSection | undefined) {
  const me = useMe().data
  return !section || posts(me?.uses, section)
}
